<template>
  <div class="layout-wrap">
    <Loading />
    <div class="header">
      <div class="header-title-logo-wrap">
        <img src="@/assets/icons/logo_white.svg" alt="蔵衛門ロゴ">
      </div>
    </div>
    <div class="front-wrap">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'FrontLayout',
}
</script>

<script setup lang="ts">
  import { defineAsyncComponent } from 'vue'
  // components
  const Loading = defineAsyncComponent(() => import('@/components/ui/Loading.vue'))
</script>

<style scoped>
.layout-wrap {
  height: 100%;
}
/** ヘッダー */
.header {
  /** 位置を固定する */
  position: fixed;
  z-index: 10;
  width: 100%;
  background-color: #1A2274;
  height: 50px;
  text-align: center;
}
.header-title-logo-wrap {
  display: inline-block;
  vertical-align: top;
  height: 50px;
  padding: 10px 0;
}
.header-title-logo-wrap > img {
  height: 30px;
}
.front-wrap {
  padding-top: 50px;
 }
</style>